import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {firstValueFrom, map, Observable} from "rxjs";

export interface EmailConfirmationResponse {
    confirmed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EmailConfirmationService {
    constructor(
        private http: HttpClient,
    ) {}

    public async isConfirmed(email: string): Promise<boolean> {
        return firstValueFrom(this.http.get<EmailConfirmationResponse>(`/api/email-confirmed/${email}/`).pipe(map(
            response => response.confirmed
        )));
    }

    public async confirmEmail(email: string, code: string): Promise<boolean> {
        return firstValueFrom(this.http.post<EmailConfirmationResponse>(`/api/confirm-email/`, {
            email,
            code,
        }).pipe(map(response => response.confirmed)));
    }
}
